export const refX = 10;
//# sourceMappingURL=MarkerDef.utils.js.map